module.exports = __webpack_public_path__ + "./assets/fonts/Montserrat-MediumItalic.ttf?40a74702035bf9ef19053c84ce9a58b9";